import { ACCESS_LEVEL_ACCESS } from "Common/dictionaries/accessLevelAccess";
import includes from "lodash/includes";
export const accessIdKeySelector = (e) => e.Id;
export const accessIdTextSelector = (e) => e.Name;
export const accessOnTextSelector = (e) => e.Id !== ACCESS_LEVEL_ACCESS.CREATOR;
export const userIdKeySelector = (e) => e.Id;
export const userIdTextSelector = (e) => e.Name || e.Id.toString();
export const userOnTextSelector = (selfUserId, existingUsersIds) => (e) => e.Id !== selfUserId && !includes(existingUsersIds, e.Id);
